import { render, staticRenderFns } from "./RegionChange.vue?vue&type=template&id=3a3a31f4&scoped=true&"
import script from "./RegionChange.vue?vue&type=script&lang=js&"
export * from "./RegionChange.vue?vue&type=script&lang=js&"
import style0 from "./RegionChange.vue?vue&type=style&index=0&id=3a3a31f4&scoped=true&lang=css&"
import style1 from "./RegionChange.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3a31f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a3a31f4')) {
      api.createRecord('3a3a31f4', component.options)
    } else {
      api.reload('3a3a31f4', component.options)
    }
    module.hot.accept("./RegionChange.vue?vue&type=template&id=3a3a31f4&scoped=true&", function () {
      api.rerender('3a3a31f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RegionChange.vue"
export default component.exports